module.exports = __webpack_public_path__ + "static/media/pdf-file.b0ed50f9.svg";